export enum UserRoles {
    ADMIN = 'Administrador',
    SECRETARIO = 'Secretario',
    SUPERVISOR = 'Supervisor',
    USUARIO = 'Usuario'
}

export const ALL_ROLES_ARRAY = Object.values(UserRoles);

export const ROLES_GROUPS = {
    ALL: [UserRoles.ADMIN, UserRoles.SECRETARIO, UserRoles.SUPERVISOR, UserRoles.USUARIO],
    MANAGEMENT: [UserRoles.ADMIN],
    BASIC_ACCESS: [UserRoles.ADMIN, UserRoles.SECRETARIO]
};